/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Verify_Capability_UnsupportedInputs */

const cs_portals_verify_capability_unsupported = /** @type {(inputs: Portals_Verify_Capability_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

const en_portals_verify_capability_unsupported = /** @type {(inputs: Portals_Verify_Capability_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`N/A`)
};

/**
* | output |
* | --- |
* | "N/A" |
*
* @param {Portals_Verify_Capability_UnsupportedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_verify_capability_unsupported = /** @type {((inputs?: Portals_Verify_Capability_UnsupportedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Verify_Capability_UnsupportedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_verify_capability_unsupported(inputs)
	return cs_portals_verify_capability_unsupported(inputs)
});